// Collection layout route — renders child routes (detail, import, entry)

import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/datahub/collections/$collectionId')({
  component: () => <Outlet />,
});
